


































































































































import Vue from 'vue'
import API from '@/utils/api'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'
import { User } from '@/models/User'
import { Team } from '@/models/Team'
import { MainGame } from '@/models/MainGame'
import PlayerStat from '@/components/PlayerStat.vue'
import moment from '@/plugins/moment'
import { Roster } from '@/models/Roster'
import { Note } from '@/models/Note'
const AppStore = namespace('AppStore')
const SnackbarStore = namespace('SnackbarStore')

@Component({
  components: { PlayerStat },
})
export default class OOR extends Vue {
  moment = moment
  @AppStore.Mutation setUser!: (user: User) => void
  @SnackbarStore.Mutation setSnackbarError!: (error: string) => void
  loading: boolean = false
  playerStatsShowed = false
  playerIdForStats = 0
  currentTeamId: number = 26
  currentGameId: number = 0
  notePlayerMarkup: any = {}
  games: MainGame[] = []
  teams: Team[] = []
  roster: Roster[] = []
  textForNewNote: string = ''
  currentNotes: Note[] = []
  seasons: number[] = []
  currentSeason: number = 0
  headers: any[] = []
  hoveredMarkupId: number = -1
  markupData: any[] = []
  currentSeasonGames: MainGame[] = []
  positions: string[] = ['RB', 'QB', 'WR', 'TE']
  addNote() {
    return API.createNote(
      this.notePlayerMarkup.player_id,
      this.notePlayerMarkup.week_id,
      this.textForNewNote
    ).then((r: any) => {
      this.loadNotesForPlayer(this.notePlayerMarkup)
      return this.loadOORMarkup()
    })
  }
  get currentGame() {
    return (
      this.games.find((g: MainGame) => g.id === this.currentGameId) || {
        id: -1,
      }
    )
  }
  showPlayerStats(playerId: number | null) {
    if (playerId) {
      this.playerIdForStats = playerId
      this.playerStatsShowed = true
    }
  }
  get nextGame() {
    let nextGames = this.currentSeasonGames.filter(
      (mg: MainGame) =>
        mg.week_id > ((this.currentGame as MainGame).week_id || 0)
    )
    if (nextGames.length > 0) {
      return nextGames.sort(
        (mg1: MainGame, mg2: MainGame) => mg1.week_id - mg2.week_id
      )[0]
    }
  }
  get prevGame() {
    let prevGames = this.currentSeasonGames.filter(
      (mg: MainGame) =>
        mg.week_id < ((this.currentGame as MainGame).week_id || 0)
    )
    if (prevGames.length > 0) {
      return prevGames.sort(
        (mg1: MainGame, mg2: MainGame) => mg2.week_id - mg1.week_id
      )[0]
    }
  }
  get hasNextGame() {
    return !!this.nextGame
  }
  get hasPrevGame() {
    return !!this.prevGame
  }
  statusChoicesForMarkup(m: any) {
    let choices = this.headers.find((h: any) => h.value === 'status_id').choices
    if (m.id !== this.hoveredMarkupId) {
      return choices.filter((c: any) => c.value === m.status_id)
    }
    return choices
  }
  getPlayerPreviousGame(mo: any) {
    let currentWeek = (this.currentGame as MainGame).week_id || 0
    let prevGames = this.currentSeasonGames
      .filter((g: MainGame) => g.week_id < currentWeek)
      .map((g: MainGame) => g.id)
    let previousMo = this.markupData.filter(
      (o: any) => o.player_id == mo.player_id && prevGames.includes(o.game_id)
    )
    previousMo.reverse()
    if (previousMo.length > 0) {
      return previousMo[0]
    }
    return undefined
  }
  isPlayerChangeStatus(mo: any) {
    let prevGame = this.getPlayerPreviousGame(mo)
    if (prevGame) {
      return prevGame.status_id != mo.status_id
    }
  }
  resetNotes() {
    this.currentNotes = []
    this.notePlayerMarkup = {}
  }
  setNextGame() {
    if (this.hasNextGame) {
      this.currentGameId = this.currentSeasonGames[this.currentGameIndex + 1].id
      this.resetNotes()
    }
  }
  get currentGameIndex() {
    let index = this.currentSeasonGames.indexOf(this.currentGame as MainGame)
    return index
  }
  setPrevGame() {
    if (this.hasPrevGame) {
      this.currentGameId = this.currentSeasonGames[this.currentGameIndex - 1].id
      this.resetNotes()
    }
  }
  get currentMarkupDataWithQB1() {
    return this.markupData.filter(
      (o) => o.game_id == (this.currentGame as MainGame).id
    )
  }
  get currentMarkupData() {
    let data = this.markupData.filter(
      (o) => o.game_id == (this.currentGame as MainGame).id
    )
    if (this.currentQb1) {
      data = data.filter(
        (o) =>
          o.player_id != this.currentQb1.player_id && o.position_name !== 'QB'
      )
    }
    return data
  }
  get currentQb1() {
    return this.markupData.find(
      (o) =>
        o.game_id == (this.currentGame as MainGame).id &&
        o.position_name == 'QB' &&
        o.is_oor === false
    )
  }
  get filteredRoster() {
    let currentWeek = (this.currentGame as MainGame).week_id || 0
    let prevWeekId = currentWeek - 1
    let currentPids = this.currentMarkupDataWithQB1.map((e) => e.player_id)
    let prevPlayedPids = this.markupData
      .filter((m) => m.week_id === prevWeekId)
      .map((e) => e.player_id)
    let currentRoster: Roster[] = this.roster.filter(
      (r: Roster) =>
        r.week_id === currentWeek && !currentPids.includes(r.player.id)
    )
    let prevRoster: Roster[] = this.roster.filter(
      (r: Roster) =>
        r.week_id === prevWeekId &&
        prevPlayedPids.includes(r.player.id) &&
        !currentPids.includes(r.player.id)
    )
    currentRoster.forEach((e) => {
      ;(e as any).is_current = true
    })
    prevRoster.forEach((e) => {
      ;(e as any).is_current = false
    })
    let prevRosterPids = prevRoster.map((r) => r.player.id)
    currentRoster = currentRoster.filter(
      (r) => !prevRosterPids.includes(r.player.id)
    )
    let res = Array(...currentRoster, ...prevRoster)
    return res
  }
  get prevGamePlayerIds() {
    return this.markupData
      .filter((o) => o.week_id == this.prevGame?.week_id)
      .map((o) => o.player_id)
  }
  getHeaderClass(header: any, m: any) {
    if (
      (['off_snaps_pct', 'total_attempts'].includes(header.value) &&
        m[header.value] == 0) ||
      (['is_injured_in_game', 'is_injured'].includes(header.value) &&
        m[header.value])
    ) {
      return 'error'
    }
    if (
      header.name === 'Off S' &&
      m[header.value] < 40 &&
      m.position_name === 'WR' &&
      m.status_id === 1
    ) {
      return 'warning'
    }
    if (
      header.name == 'Name' &&
      this.prevGamePlayerIds.length &&
      !this.prevGamePlayerIds.includes(m.player_id)
    ) {
      return 'warning'
    }
    if (header.name === 'Status') {
      return 'status'
    }
  }
  isLastPos(m: any) {
    let filteredM = this.currentMarkupData.filter(
      (o) => o.position_name == m.position_name
    )
    let lastM = filteredM[filteredM.length - 1]
    return (
      lastM.player_id === m.player_id &&
      this.currentMarkupData[this.currentMarkupData.length - 1].player_id !==
        m.player_id
    )
  }
  saveOOR() {
    let oorsToSave: any[] = []
    this.currentMarkupData.forEach((e) =>
      oorsToSave.push({
        id: e.id,
        is_oor_new: e.is_oor_new,
        is_main: e.is_main,
        is_bench: e.is_bench,
        status_id: e.status_id,
      })
    )
    return API.saveOORMarkup(oorsToSave)
  }
  onCheckboxUpdate(x: any) {
    this.loading = true
    this.saveOOR().then((r) => {
      this.loadOORMarkup()
    })
  }

  loadNotesForPlayer(m: any) {
    this.loading = true
    this.currentNotes = []
    return API.getNotesForPlayer(m.player_id, m.week_id)
      .then((r) => {
        this.currentNotes = r.data
      })
      .catch((err: any) => {})
      .finally(() => {
        this.loading = false
      })
  }
  setCurrentSeasonGames() {
    let gameIds: number[] = []
    this.markupData.forEach((e) => {
      gameIds.push(e.game_id)
    })
    this.currentSeasonGames = this.games.filter((g: MainGame) => {
      return gameIds.includes(g.id)
    })
  }
  loadSeasons() {
    return API.loadSeasons().then((r) => {
      this.seasons = r.data
      this.currentSeason = Math.max(...this.seasons)
    })
  }
  loadTeams() {
    return API.loadTeams().then((r) => {
      this.teams = r.data
    })
  }
  loadHeaders() {
    return API.loadOORHeaders().then((r) => {
      this.headers = r.data
    })
  }
  loadGames() {
    this.loading = true
    return API.loadGames().then((r) => {
      this.games = r.data
      this.loading = false
    })
  }
  loadOORMarkup() {
    this.loading = true
    API.loadSeasonRoster(this.currentTeamId, this.currentSeason).then((r) => {
      this.roster = r.data
    })
    return API.loadOORMarkup(this.currentTeamId, this.currentSeason)
      .then((r) => {
        this.markupData = r.data
        this.setCurrentSeasonGames()
        let currentGameIds: number[] = []
        this.currentSeasonGames.forEach((g: MainGame) =>
          currentGameIds.push(g.id)
        )
        if (!currentGameIds.includes((this.currentGame as MainGame).id || -1)) {
          this.currentGameId =
            this.currentSeasonGames[this.currentSeasonGames.length - 1].id
        }
      })
      .catch((e) => {})
      .finally(() => {
        this.loading = false
      })
  }
  mounted() {
    this.loadSeasons()
    this.loadTeams()
    this.loadGames()
    this.loadHeaders()
  }
}
